<template>
    <div v-if="submitting"
         class="fixed-content-width">
        <loading-container  />
    </div>
    <div class="exhibitor-detail-page detail-page-container" v-else>
        <div v-if="vendor && !submitting"
             class="detail-page"
             :class="{'edit-mode': showEditControls}"
             ref="mainScrollContainer">
            <vue-title :title="vendor.Name" :brand="true"></vue-title>

            <media-container v-if="vendor.PrimaryMedia"
                             :media="vendor.PrimaryMedia"
                             :entityTypeCode="'VENDOR'"
                             :entityCode="vendor.Code"
                             :fallbackPhoto="vendor.ContactInfo.PhotoUrl"
                             :forceShow="showEditControls"
                             :editMode="showEditControls"
                             @cover-click="onUploadCoverPhoto"
                             @dragover="onDragOverProfileOrCoverPhoto"
                             @drop="onDropCoverPhoto">

            </media-container>

            <div class="detail-page-summary">
               
                <div class="exhibitor-summary"
                     ref="summaryToolbar">

                    <div class="exhibitor-logo"
                         v-if="vendor.ContactInfo.PhotoUrl || showEditControls"
                         @click="onUploadProfilePhoto">
                        <img-g :src="vendor.ContactInfo.PhotoUrl"
                               @dragover="onDragOverProfileOrCoverPhoto"
                               @click="onUploadProfilePhoto"
                               @drop="onDropProfilePhoto" />
                    </div>

                    <div class="exhibitor-name-and-menu">
                        <h1 class="exhibitor-name">
                            {{vendor.Name}}
                        </h1>
                        <h2 class="exhibitor-headline"
                            v-if="vendor.Headlines">
                            {{vendor.Headlines}}
                        </h2>
                        <!-- <input v-else v-model="vendor.Name"> -->

                        <h3 v-if="vendor.Location"
                            class="exhibitor-location">
                            <span class="icomoon"></span>{{vendor.Location}}
                        </h3>

                        <div class='horizontal-menu'>

                            <button type="button"
                                    class="icomoon button-outline"
                                    v-if="!editMode"
                                    :class="[vendorModel.CanEditFavorite ? '' : 'button-noninteractive-fill']"
                                    @click="onToggleFavorite">
                                {{vendorModel.IsFavorite ? '' : ''}}
                            </button>

                            <router-link class="btn button-outline"
                                         v-if="canViewVisits && !editMode"
                                         :to="{name: 'ProfileViewsVendor'}">
                                <span class="icomoon"></span><span>Visitors</span>
                            </router-link>

                            <button @click="editMode = true"
                                    v-if="!editMode && canEditPage"
                                    class="button-outline"
                                    type="button">
                                <span class="icomoon"></span><span>Edit</span>
                            </button>

                            <button type="button"
                                    v-if="editMode && canEditPage"
                                    @click="showPageEditorPane">
                                <span class="icomoon">
                                    
                                </span>
                                <span>
                                    Details
                                </span>
                            </button>

                            <button @click="previewChangesMode = !previewChangesMode"
                                    :class="{'button-outline' : !previewChangesMode}"
                                    type="button"
                                    v-if="editMode && canEditPage">
                                <span class="icomoon">
                                    
                                </span>
                                <span v-if="previewChangesMode">
                                    Exit Preview
                                </span>
                                <span v-else>
                                    Preview
                                </span>
                            </button>

                            <button @click="savePageChanges"
                                    type="button"
                                    v-if="showEditControls && canEditPage">
                                <span class="icomoon">
                                    
                                </span>
                                <span>
                                    Save
                                </span>
                            </button>

                            <button @click="abortPageChanges"
                                    type="button"
                                    v-if="showEditControls && canEditPage">
                                <span class="icomoon">
                                    
                                </span>
                                <span>
                                    Cancel
                                </span>
                            </button>
                            <template v-if="showEditControls && canEditPage">
                                <button v-for="item in newElementTypes" 
                                        :key="item.Code"
                                        draggable="true" 
                                        @dragstart="onDragStartNewElement(item.Code)"
                                        @dragend="onDropCleanup"
                                        @drag="onDragNewElement"
                                        @click="addItem(item.Code)">Add {{item.Name}}
                                </button>
                            </template>
                        </div>
                    </div>


                </div>

                <p v-if="vendor.ContactInfo.Bio && !showEditControls"
                   class="detail-page-bio-text"
                   v-html="biography">
                </p>

                <contact-info-list :contactInfo="vendor.ContactInfo.ContactInfo"
                                   :entityType="'Vendor'"
                                   :entityCode="code"
                                   :editMode="editMode && !previewChangesMode"
                                   ref="contactInfoEditor"
                                   @upload-event="onContactInfoUploadEvent"
                                   @drag-scroll-requested="onAutoScrollTimer"
                                   @drag-update="onDragUpdate">
                </contact-info-list> 

                <template v-if="showEditControls">

                    <file-upload ref="uploaderCover"
                        style="display: none;"
                        :assetType="`vendor_${this.code}`"
                        @uploadSuccess="onFileUploadedCover"
                        @uploadFailed="onUploadFailed"
                        @uploadStarted="onUploadStarted" />


                    <file-upload ref="uploaderProfilePhoto"
                        style="display: none;"
                        :assetType="`vendorprofile_${this.code}`"
                        :acceptFileType='"image/png, image/gif, image/jpeg"'
                        @uploadSuccess="onProfilePhotoUploaded"
                        @uploadFailed="onUploadFailed"
                        @uploadStarted="onUploadStarted" />
                </template>

                <div class="upload-page-modal-blocker"
                     v-if="uploadInProgress">
                    <h1>
                        Uploading file, please wait...
                    </h1>
                    <loading-container />
                </div>

            </div>
        </div>
        <router-view :typeCode="'Vendor'" 
                     :code="code"
                     class="right-pane">
        </router-view>
    </div>
</template>
<script>
import Token from './authentication/token'
import Common from './common'
import { AppState } from './appstate';

export default {
    props: ['code'],
    mixins: [
        Token,
        Common
    ],   

    watch: {
        code(to, from) {
            this.build();
        },
        editMode(to, from) {
            if(to) {
                this.previewChangesMode = false;
                this.showPageEditorPane();
            } else {
                window.$bus.$emit('closeSidebar', 'contact-info');
                window.$bus.$emit('closeSidebar', 'page-editor');
            }
        }
    },

    computed: {

        biography() {
            return this.markdown(this.vendor.ContactInfo.Bio);
        },


        editableElements: {
            get() {
                return this.selectedSection.Elements.filter(x => {
                    let isSkippable = x.SkipInEditMode;
                    let containsInternal = x.Type == 'Website' && x.Value && x.Value.indexOf('INTERNAL:::') != -1;
                    let isImage = x.Type == 'Image'
                    return !isSkippable && !containsInternal && !isImage;
                });
            }, 
            set(value) {
                if(this.selectedSection == this.sections[0]) {
                    let fixedItem = this.selectedSection.Elements.filter(x => x.SkipInEditMode);
                    
                    this.selectedSection.Elements = [...fixedItem, ...value];
                } else {
                    this.selectedSection.Elements = value;
                }
            }
        },

        canEditPage() {
            let isAdmin = AppState.attendee.RoleCode && AppState.attendee.RoleCode == 'Administrator';

            return isAdmin || this.canViewVisits;
        },

        showEditControls() {
            return this.editMode && !this.previewChangesMode;
        }
    },

    async beforeRouteLeave(to, from, next) {
        this.postExitAnalytics();
        next();
    },

    methods: {
        showPageEditorPane() {
            window.$bus.$emit('set-sidebar-mode', 'page-editor', {
                EntityTypeCode: "VENDOR",
                EntityCode: this.code,
                Page: this.vendor,
                HadPageAccessPassword: this.hadPageAccessPassword,
                GetPageAccessPassword: this.getPageAccessPassword,
                SetPageAccessPassword: this.setPageAccessPassword
            });
        },

        getPageAccessPassword() {
            return this.pageAccessPassword;
        },

        setPageAccessPassword(value) {
            this.pageAccessPassword = value;
        },

        addItem(code) {
            this.$refs.contactInfoEditor.addItem(code, null);

            this.$nextTick(() => {
                this.$refs.mainScrollContainer.scrollTo(0, this.$refs.mainScrollContainer.scrollHeight);
            });
        },

        onToggleFavorite() {
            let pageModel = this.vendorModel;

            if(!pageModel.CanEditFavorite) {
                return;
            }

            window.$bus.$emit('request-toggle-favorite', {
                Type: "VENDOR",
                Code: pageModel.Vendor.Code,
                ReadOnly: false,
                AllowEditEntity: pageModel.IsPageAdmin,
                Active: !pageModel.IsFavorite
            });

            return false;
        },

        onWebinarExitRequested() {
            this.forceWebinarMode = false;
        },

        postExitAnalytics() {
            this.postAnalytics(AppState.attendee.Code,'VendorExit',this.code,'Vendor',AppState.show.Code);
        },

        onUploadProfilePhoto() {
            if(!this.editMode) {
                return;
            }
            console.log('Test')
            this.$refs.uploaderProfilePhoto.requestChooseFile();
        },

        onUploadCoverPhoto() {
            if(!this.editMode) {
                return;
            }
            
            this.$refs.uploaderCover.requestChooseFile();
        },

        onUploadFile(selectedUploadCandidate) {
            if(selectedUploadCandidate.IsLocked && AppState.attendee.RoleCode != 'Administrator'){
                return;
            }
            this.selectedUploadCandidate = selectedUploadCandidate;
            this.$refs.uploader.requestChooseFile();
        },

        onContactInfoUploadEvent(eventName) {
            if(eventName == 'success') {
                this.uploadInProgress = false;
            } else if (eventName == 'failed') {
                this.uploadInProgress = false;
                this.$awn.alert('Could not upload your file. Try again later.');
            } else {
                this.uploadInProgress = true;
            }
        },

        onUploadStarted() {
            this.uploadInProgress = true;
        },

        onUploadFailed() {
            this.uploadInProgress = false;
            this.$awn.alert('Could not upload your file. Try again later.');
        },

        onProfilePhotoUploaded(file) {
            this.uploadInProgress = false;
            this.vendor.ContactInfo.PhotoUrl = file;
        },        

        onFileUploadedCover(file) {
            this.uploadInProgress = false;
            this.vendor.PrimaryMedia.ThumbnailUri = file;
        },        


        abortPageChanges() {
            this.pageAccessPassword = '';
            this.editMode = false;
            this.build();
        },

        async savePageChanges() {
            this.submitting = true;

            if(this.vendor.HasPageAccessPassword && !this.hadPageAccessPassword && !this.pageAccessPassword.trim()) {
                this.$awn.alert('Enter a Page password.');
                this.submitting = false;
                return;
            }

            window.$bus.$emit('closeSidebar', 'contact-info');
            window.$bus.$emit('closeSidebar', 'page-editor');

            this.vendor.ContactInfo.ContactInfo = [...this.$refs.contactInfoEditor.contactInfoList];

            try {
                let toSave = JSON.parse(JSON.stringify(this.vendor));
                toSave.PageAccessPassword = toSave.HasPageAccessPassword ? this.pageAccessPassword.trim() : '';
                toSave.ClearPageAccessPassword = !toSave.HasPageAccessPassword;
                let result = await this.tryPost(
                    '/api/vendor', 
                    JSON.stringify(toSave),
                    'application/json');

                if(result.Errors && result.Errors.length > 0) {
                    this.$awn.alert('Could not save Page. Try again later.');
                    return;
                }

                this.pageAccessPassword = '';
                this.editMode = false;
                await this.build();

            } catch(ex) {
                this.$awn.alert('Could not save Page. Try again later.');
            } finally {
                this.submitting = false;
            }
        },

        async build() {
            this.submitting = true && !this.vendor;

            let result = await this.tryGet(`/api/vendor/${AppState.show.Code}/${this.code}`);

            if(!result.Result || !result.Result.Vendor) {
                this.$awn.alert("We're sorry. This page does not exist.");
                this.$router.go(-1);
                return;
            }

            this.vendorModel = result.Result;
            this.vendor = result.Result.Vendor;
            this.vendor.PublicWebEnabled = !!this.vendor.PublicWebEnabled;
            this.vendor.PublicWebLightMode = !!this.vendor.PublicWebLightMode;
            this.vendor.HidePublicNavbar = !!this.vendor.HidePublicNavbar;
            this.vendor.CaptureGateEnabled = !!this.vendor.CaptureGateEnabled;
            this.vendor.HasPageAccessPassword = !!this.vendor.HasPageAccessPassword;
            this.vendor.PageAccessPassword = '';
            this.hadPageAccessPassword = this.vendor.HasPageAccessPassword;

            this.postAnalytics(AppState.attendee.Code,'VendorDetails',this.code,'Vendor',AppState.show.Code);

            this.allowRehearsal = false;


            let isAdmin = AppState.attendee.RoleCode && AppState.attendee.RoleCode == 'Administrator';

            try {
                this.canViewBookings = 
                    (this.vendorModel.IsPageAdmin
                    || isAdmin);
            } catch {

            }

            try {

                this.canViewVisits = (isAdmin 
                    || this.vendorModel.IsPageAdmin);
            } catch {

            }

            this.submitting = false;
        },

        onEntityUpdated(details) {
            if(details.EntityTypeCode != "VENDOR" || details.EntityCode != this.code) {
                return;
            }

            if(this.editMode) {
                return;
            }

            this.build();
        },

        onFavoritesUpdated(favorites) {
            if(!favorites) {
                this.build();
            } else {

                let favorite = favorites.find(x => x.EntityTypeCode == 'VENDOR' && x.EntityCode == this.vendor.Code);

                if(!favorite) {
                    return;
                }

                this.vendorModel.IsFavorite = favorite.IsActive;
            }

        },

        onDragStartNewElement(newElementType) {
            this.$refs.contactInfoEditor.onDragStartNewElement(newElementType);
        },

        onDragNewElement(e) {
            this.$refs.contactInfoEditor.onDrag(null, e);
        },

        onDropCleanup() {
            this.$refs.contactInfoEditor.onDropCleanup();
        },

        onDragUpdate(e) {
            let boundingRect = this.$refs.summaryToolbar.getBoundingClientRect();
            let yBoundaryToolbar = boundingRect.y + boundingRect.height;
            let browserHeight = window.innerHeight;
            let mouseY = e.mouseY;

            let direction = 0; 

            if(mouseY <= yBoundaryToolbar - 24) {
                direction = -16;
            } else if (mouseY > browserHeight - 96) {
                direction = 16;
            } else {
                direction = 0;
            }

            // console.log("Scroll Details (mouseY, yBoundary, browserHeight, direction)",
            //     mouseY,
            //     yBoundaryToolbar,
            //     browserHeight,
            //     direction);

            this.$refs.contactInfoEditor.updateScrollAmount(direction);
        },

        onAutoScrollTimer(direction) {
            if(!direction || direction == 0) {
                return;
            }

            this.$refs.mainScrollContainer.scrollTo(0, this.$refs.mainScrollContainer.scrollTop + direction);
        },


        onDragOverProfileOrCoverPhoto(e) {
            if(!this.editMode) {
                return;
            }
            e.preventDefault();
        },

        async onDropProfilePhoto(e) {
            if(!this.editMode) {
                return;
            }

            e.preventDefault();

            let file = e.dataTransfer.files[0];
            if(!file.type.startsWith('image/')) {
                this.$awn.alert("This file is not an image. Please upload an image (e.g. JPG, PNG).");
                return;
            }

            await this.$refs.uploaderProfilePhoto.uploadFile(e.dataTransfer.files[0]);
        },

        async onDropCoverPhoto(e) {
            if(!this.editMode) {
                return;
            }

            e.preventDefault();

            let file = e.dataTransfer.files[0];
            if(!file.type.startsWith('image/')) {
                this.$awn.alert("This file is not an image. Please upload an image (e.g. JPG, PNG).");
                return;
            }

            await this.$refs.uploaderCover.uploadFile(e.dataTransfer.files[0]);
        },

        onPageDetailsEdited(entityTypeCode, entityCode, page) {
            if(entityTypeCode != "VENDOR" || entityCode != this.vendor.Code) {
                return;
            }

            // TODO: See if we can use a ref() wrapped model for the vendor so we can pass around
            // a single source of truth.
            this.vendor.Name = page.Name;
            this.vendor.Headlines = page.Headlines;
            this.vendor.ContactInfo.Bio = page.ContactInfo.Bio;
            this.vendor.PrimaryMedia.Uri = page.PrimaryMedia.Uri;
            this.vendor.PrimaryMedia.MediaType = page.PrimaryMedia.MediaType;
            this.vendor.PublicWebEnabled = page.PublicWebEnabled;
            this.vendor.PublicWebLightMode = page.PublicWebLightMode;
            this.vendor.HidePublicNavbar = page.HidePublicNavbar;
            this.vendor.CaptureGateEnabled = page.CaptureGateEnabled;
            this.vendor.HasPageAccessPassword = page.HasPageAccessPassword;
            
        },

        async onPaste(e) {
            if(!this.editMode) {
                return;
            }

            if(e.target?.tagName != "BODY") {
                return;
            }

            try {
                let clipboardContents = await navigator.clipboard.read();

                console.log(clipboardContents);

                if(clipboardContents.length == 0) {
                    return;
                }

                const imageRaw = clipboardContents[0];
                const type = imageRaw.types[0];

                if(!type.startsWith('image/')) {
                    console.warn("Not an image.");
                    return;
                }

                const blob = await imageRaw.getType(type);


                console.log(blob);
                this.$refs.contactInfoEditor.onPaste(blob);
            } catch(ex) {
                console.error("Error on read clipboard.", ex);
            }

        }
    },

    data() {
        return {
            vendorModel: null,
            vendor: null,
            canViewBookings: false,
            canViewVisits: false,
            sections: [],
            selectedSection: null,
            streamDetails: null,
            submitting: false,
            editMode: false,
            previewChangesMode: false,
            uploadInProgress: false,
            selectedUploadCandidate: null,
            allowRehearsal: false,
            pageAccessPassword: '',
            hadPageAccessPassword: false,

            newElementTypes: [
                {
                    Code: 'Email',
                    Name: 'E-Mail'
                },
                {
                    Code: 'Website',
                    Name: 'Link'
                },
                {
                    Code: 'Downloadable',
                    Name: 'Download'
                },
                {
                    Code: 'Image',
                    Name: 'Image'
                },
                {
                    Code: 'Section',
                    Name: 'Text'
                },
                {
                    Code: 'SessionCategory',
                    Name: 'Session Category'
                },
                {
                    Code: 'LoginHeader',
                    Name: 'Login Header'
                },
                {
                    Code: 'LoginFooter',
                    Name: 'Login Footer'
                }
            ]
        }
    },

    beforeUnmount() {
        this.pageAccessPassword = '';
        window.$bus.$off('entity-updated', this.onEntityUpdated);
        window.$bus.$off('favorites-updated',this.onFavoritesUpdated);
        window.$bus.$off('PageDetailsEdited', this.onPageDetailsEdited);
        window.$bus.$emit('closeSidebar', 'contact-info');
        window.$bus.$emit('closeSidebar', 'page-editor');
        window.removeEventListener('paste', this.onPaste);
    },

    created: function() {
        this.build();
        window.$bus.$on('entity-updated', this.onEntityUpdated);
        window.$bus.$on('favorites-updated',this.onFavoritesUpdated);
        window.$bus.$on('PageDetailsEdited', this.onPageDetailsEdited);
        window.addEventListener('paste', this.onPaste);
    },
}
</script>
